import ErrorIcon from "@mui/icons-material/Error";
import { Typography } from "@mui/material";
import { type FieldProps, LinearProgress, useRecordContext } from "react-admin";
import { Student } from "../providers/studentsProvider";
import { assertDefined } from "../backoffice.utils";
import { drivingSchoolsProvider } from "../providers/drivingSchoolsProvider";

export function StudentBranchField(_props: FieldProps) {
  const student = useRecordContext<Student>();

  if (!student) return <LinearProgress />;

  const drivingSchool = assertDefined(
    drivingSchoolsProvider.getOneFromCache(student.drivingSchoolId),
    `drivingSchoolsProvider.getOneFromCache(${JSON.stringify(student.drivingSchoolId)})`,
  );
  const assignedBranchId = student.branchId ?? drivingSchool.defaultBranch.uid;
  const assignedBranch = drivingSchool.branchesById[assignedBranchId];

  if (!assignedBranch) {
    return <ErrorIcon role="presentation" color="error" fontSize="small" />;
  }

  return (
    <Typography component="span" variant="body2">
      {assignedBranch.name}
    </Typography>
  );
}
